import { render, staticRenderFns } from "./CoverModal.vue?vue&type=template&id=52e04755"
import script from "./CoverModal.vue?vue&type=script&lang=js"
export * from "./CoverModal.vue?vue&type=script&lang=js"
import style0 from "./CoverModal.vue?vue&type=style&index=0&id=52e04755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports